import Skeleton from 'react-loading-skeleton';
import styles from '@components/ProductCardNew/ProductCardDescription/ProductDescription.styles';
const ProductCardDesriptionSkeleton = () => <div sx={styles.descriptionSkeletonContainer}>
    <Skeleton count={1} height={18} width={100} sx={styles.infoNameSkeleton} />
    <Skeleton count={1} height={18} width={60} sx={styles.infoPriceSkeleton} />
    <Skeleton count={1} height={12} width={140} sx={styles.infoPriceSkeleton} />
    <Skeleton sx={styles.infoColorSkeleton} height={16} width={16} count={3} circle inline />
  </div>;
export default ProductCardDesriptionSkeleton;